var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -1314) translate(444 1314)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M61.85 53.372c0 5.457-3.85 9.878-8.591 9.878H8.59C3.846 63.25 0 58.829 0 53.372v-32.14C0 16.638 21.747 4.328 28.62.552c1.291-.708 2.78-.737 4.005-.076 6.82 3.682 29.225 16.129 29.225 20.756v32.14",
    transform: "translate(-444 -1314) translate(444 1314) translate(13 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M10.735 5.591c-1.938 0-3.56 1.2-3.56 2.717v51.016c0 1.518 1.597 2.735 3.537 2.735l.023-.018h40.43v.018c1.817 0 3.31-1.074 3.489-2.462.013-.092.013-.176.013-.273V8.308c0-1.518-1.564-2.717-3.501-2.717H10.735z",
    transform: "translate(-444 -1314) translate(444 1314) translate(13 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E97FC",
    d: "M61.847 21.982v31.892c-.179 2.63-.973 4.531-1.995 5.904-2.414 3.242-6.114 3.543-6.114 3.543L30.925 40.486l30.922-18.504",
    transform: "translate(-444 -1314) translate(444 1314) translate(13 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFFF",
    d: "M30.925 40.486L8.11 63.321s-3.7-.3-6.116-3.543C.974 58.405.185 56.505 0 53.874V21.982l30.925 18.504",
    transform: "translate(-444 -1314) translate(444 1314) translate(13 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M59.852 59.778c-2.414 3.242-6.114 3.543-6.114 3.543H8.111s-3.7-.3-6.116-3.543l28.93-19.292 28.927 19.292",
    transform: "translate(-444 -1314) translate(444 1314) translate(13 12)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesChat);
export default __webpack_public_path__ + "static/media/features-chat.74d615bb.svg";
export { ForwardRef as ReactComponent };